<template>
  <div class="import-tool">
    <Modal v-model="visible" title="批量导入" :mask-closable="false" width="530" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div class="box">
        <p class="text1">支持两种导入方式：</p>
        <p class="text2">1、导出当前结算数据，新增或修改费率后导入。</p>
        <p class="text2">2、下载模板录入数据后导入。</p>
        <span class="tips">提示：每次导入只新增或更新表里对应记录的费用，不在导入表里的记录系统不做删除处理，如需删除请手动删除</span>
      </div>
      <div class="ivu-modal-footer">
        <Button type="primary" ghost class="export" @click="exportTable()">导出当前结算数据</Button>
        <Button type="primary" ghost @click="download">下载导入模板</Button>
        <Upload
          ref="upload"
          v-if="data.uploadUrl"
          :show-upload-list="false"
          class="upload-btn"
          :max-size="2048"
          :before-upload="handleBeforeUpload"
          :action="data.uploadUrl"
        >
          <Button type="primary" :loading="loading" :class="{ 'import-btn': loading }">导入结算数据</Button>
        </Upload>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fileFormat: ['xls', 'xlsx', 'XLS', 'XLSX'],
      visible: false,
      loading: false,
      data: {}
    };
  },
  methods: {
    open(data = {}) {
      this.data = data;
      this.loading = false;
      this.visible = true;
    },
    // 导出当前结算数据
    exportTable() {
      if (!this.$units.pointAction('offline_82_3_5')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$emit('exportTable', 1)
    },
    // 下载导入模版
    download() {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile(this.data.template, this.data.params, 'GET', this.data.templateName);
    },
    handleBeforeUpload(file) {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const format = file.name.split('\.')[1];
      if (!this.fileFormat.includes(format)) {
        this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      formData.append('reportId', this.data.reportId);
      this.loading = true;
      this.$http({
        type: 'POST',
        url: this.data.uploadUrl,
        data: formData
      })
        .then(res => {
          if (res.data.errorList) {
            const successNum = res.data.successList && res.data.successList.length;
            const errorNum = res.data.errorList && res.data.errorList.length;
            let text = `系统已成功导入${successNum}条数据`;
            if (errorNum) {
              text = text + `，存在${errorNum}条数据未导入`;
              if (this.data.errorUrl) {
                this.$units.downloadFile(
                  this.data.errorUrl,
                  {
                    errorList: res.data.errorList,
                    reportId: this.data.reportId
                  },
                  'POST'
                );
              }
              this.$notice.error(text);
            } else {
              this.visible = false;
              this.$notice.success(text);
            }
            this.$emit('success');
          } else {
            this.visible = false;
            this.$notice.success(`系统已成功导入${res.data.successCount}条数据`);
            this.$emit('success');
          }
        })
        .finally(() => {
          this.loading = false;
        });
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .ivu-modal-header-inner {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
  }
  .ivu-modal-close {
    top: 4px;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #a8adb7;
    }
  }
  .ivu-modal-header {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  .box {
    padding-top: 15px;
    padding-bottom: 10px;
    font-size: 12px;
    .text1 {
      color: #515c6f;
      margin-bottom: 15px;
    }
    .text2 {
      margin-bottom: 10px;
    }
    .tips {
      display: block;
      margin-top: 20px;
    }
  }
  .ivu-modal-footer {
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .iconfont {
      font-size: 14px;
      margin-right: 4px;
    }
    .upload-btn {
      margin-left: auto;
      .import-btn {
        width: 120px;
      }
    }
    .export {
      width: 130px;
    }
  }
}
</style>
